export const TABLET_MEDIA_QUERY = `(max-width: 800px)`;

export const defaultHeaderModelData = {
  isViewChanged: false
};

export const defaultHeaderCategoryModelData = {
  isOpenedSubList: false
};

export const ActionType = {
  CHANGE_VIEW: `CHANGE_VIEW`,
  RESET_VIEW: `RESET_VIEW`,
  OPEN_SUBLIST: `OPEN_SUBLIST`,
  CLOSE_SUBLIST: `CLOSE_SUBLIST`
};

export const DEBOUNCE_TIME = 200;

export const ANIMATION_DURATION = 10;
